import { TButtonSize } from '@cian/ui-kit/button/types';
import { UIHeading2, UIText2 } from '@cian/ui-kit';
import { Button } from '@cian/ui-kit/button';
import * as React from 'react';
import { useDispatch } from 'react-redux';

import { requestAuthentication } from '../../actions/authentication';
import { trackSearchOffersButtonClick, trackSignInButtonClick } from './tracking';
import { IFiltersState } from '../../types/filters';
import { TUser } from '../../types/user';
import { getSearchUrl } from '../../utils/filters';

import * as styles from './ResultsEmpty.css';

export interface IResultsEmptyProps {
  user: TUser;
  filters: IFiltersState;
  size: TButtonSize;
}

export const ResultsEmpty: React.FC<IResultsEmptyProps> = ({ user: { isAuthenticated }, filters, size }) => {
  const dispatch = useDispatch();

  const handleButtonClick = React.useCallback(() => {
    if (isAuthenticated) {
      window.location.assign(getSearchUrl(filters));
      trackSearchOffersButtonClick();
    } else {
      dispatch(requestAuthentication());
      trackSignInButtonClick();
    }
  }, [dispatch, filters, isAuthenticated]);

  return (
    <div className={styles['container']}>
      <div className={styles['wrapper']}>
        <div className={styles['content']}>
          <div className={styles['empty-background']} />
          <div className={styles['title']}>
            <UIHeading2>Добавляйте&nbsp;объявления в избранное</UIHeading2>
          </div>
          <div className={styles['description']}>
            <UIText2>Отмечайте интересные объявления и следите за изменением цены</UIText2>
          </div>
          <Button size={size} theme="fill_primary" onClick={handleButtonClick}>
            {isAuthenticated ? 'Искать объявления' : 'Войти'}
          </Button>
        </div>
      </div>
    </div>
  );
};
